<template>
  <AppPage class="SendOrderPage">
    <AppHeader
      :left-action="onBack"
      :right-action="sendOrder"
      hideNumber
      right-icon="paper-plane"
      title="RESUMEN DEL PEDIDO"
    />
    <AppSection>
      <OrderDetails
        :location="location"
        :order="order"
        @sendOrder="sendOrder"
        ref="orderDetails"
        v-if="order"
      />
    </AppSection>
    <AppSection title="CONDICIONES DEL SERVICIO">
      <ToggleButton
        @input="onConditionsSelected"
        label="PULSAR AQUI PARA VER Y ACEPTAR LAS CONDICIONES DE VENTA"
        label-selected="HE LEIDO Y ACEPTO LAS CONDICIONES DE VENTA"
        v-model="conditions"
      />
    </AppSection>
    <AppSection title="DETALLES DE CONTACTO">
      <div class="form-group">
        <label>
          NOMBRE Y APELLIDOS
          <small>
            <i class="fa fa-asterisk" /> requerido
          </small>
        </label>
        <input class="form-control" type="text" v-model="contact.name" />
      </div>
      <div class="form-group">
        <label>
          EMAIL DE CONTACTO
          <small>
            <i class="fa fa-asterisk" /> requerido
          </small>
        </label>
        <input class="form-control" type="text" v-model="contact.email" />
      </div>
      <div class="form-group">
        <label>
          TELEFONO DE CONTACTO
          <small>
            <i class="fa fa-asterisk" /> requerido
          </small>
        </label>
        <input class="form-control" type="text" v-model="contact.phone" />
      </div>
      <div class="form-group">
        <label>OBSERVACIONES</label>
        <textarea class="form-control" rows="4" v-model="contact.comments"></textarea>
      </div>
    </AppSection>
    <!-- Formulario de pago -->
    <PaymentForm :paymentData="paymentData" v-if="paymentData" :order="orderId" :user="userId" />
  </AppPage>
</template>
<script>
import { usersRef } from "../firebase";
import OrderDetails from "../components/Order/OrderDetails";
import PaymentForm from "../components/Payment/PaymentForm";
import ToggleButton from "../components/Controls/ToggleButton";

export default {
  components: { OrderDetails, PaymentForm, ToggleButton },
  data() {
    return {
      orderId: null,
      userId: null,
      paymentData: null,
      location: {},
      contact: {
        name: "",
        phone: "",
        email: "",
        comments: ""
      },
      conditions: false,
      order: [],
      date: Date.now()
    };
  },
  mounted() {
    const user = this.$store.getters.user || {};
    const order = this.$store.getters.order || [];
    const order_location = this.$store.getters.order_location;

    if (!user) this.$router.push("/");
    else if (!order || order.length === 0) this.$router.push("/catalog");
    else {
      this.userId = user.uid;
      this.contact.name = user.displayName || "";
      this.contact.email = user.email || "";
      this.contact.phone = user.phone || "";
      this.location = order_location;
      this.order = Object.values(order);
    }
    this.$store.commit(
      "setInfo",
      `<p>SI QUIERES QUE TE ENTREGUEMOS TU PEDIDO UN DÍA Y HORA CONCRETA, INDICANOSLO EN EL CUADRO DE OBSERVACIONES</p> GRACIAS`
    );
  },
  methods: {
    onConditionsSelected(value) {
      if (value) this.onShowConditions();
    },
    onShowConditions() {
      this.$store.commit("showConditions", true);
    },
    onBack() {
      this.$router.push("/order");
    },
    async sendOrder() {
      this.$store.commit("isLoading", true);

      if (
        !this.contact.name ||
        this.contact.name === "" ||
        !this.contact.phone ||
        this.contact.phone === "" ||
        !this.contact.email ||
        this.contact.email === "" ||
        !this.conditions
      ) {
        this.$store.commit(
          "setError",
          "DEBES RELLENA LOS CAMPOS REQUERIDOS Y ACEPTAR LAS CONDICIONES"
        );
        this.$store.commit("isLoading", false);
        return;
      }
      const uid = this.$store.state.profile.user.uid;
      const order = this.$store.state.profile.order;
      const location = this.$store.state.profile.order_location;
      const contact = this.contact;
      const total = this.$refs.orderDetails.totalTotal;
      const totalSendPrice = this.$refs.orderDetails.totalSendPrice;

      this.$store.commit("isLoading", true);

      const newOrder = {
        date: Date.now(),
        contact,
        location,
        total,
        order,
        totalSendPrice
      };

      /** seteamos los datos de contacto del usuario */
      await usersRef
        .child(uid)
        .child("user")
        .set({
          uid: uid,
          displayName: contact.name,
          email: contact.email,
          phone: contact.phone
        })
        .catch(error => this.$store.commit("setError", error.message));

      if (!location || !location.address || !location.destination) {
        delete newOrder.location;
      } else {
        const data = {
          transport: 1,
          originAddress: "Via Augusta, 105, Barcelona",
          originLatitude: 41.401069,
          originLongitude: 2.148427,
          originComment: "",
          destinationAddress: newOrder.location.address,
          destinationLatitude: newOrder.location.destination.lat,
          destinationLongitude: newOrder.location.destination.lng,
          destinationComment: newOrder.contact.comments,
          contactPhone: newOrder.contact.phone,
          contactName: newOrder.contact.name,
          numItems: Object.keys(newOrder.order || []).length
        };
      }

      if (!this.orderId) {
        const orderResult = await usersRef
          .child(uid)
          .child("orders")
          .push(newOrder)
          .catch(error => this.$store.commit("setError", error.message));
        this.orderId = orderResult.key;
      } else {
        const orderResult = await usersRef
          .child(uid)
          .child("orders")
          .child(this.orderId)
          .set(newOrder)
          .catch(error => this.$store.commit("setError", error.message));
      }

      const paymentData = await this.$store.dispatch("getPaymentData", {
        user: uid,
        orderId: this.orderId,
        total: newOrder.total.replace(".", "").replace(",", "")
      });

      if (!paymentData) {
        this.$store.commit("setError", "Ocurrión un error, intentelo de nuevo");
      } else {
        await usersRef
          .child(uid)
          .child("order")
          .remove()
          .catch(error => this.$store.commit("setError", error.message));
        this.paymentData = paymentData;
      }
    }
  }
};
</script>
<style lang="scss">
.SendOrderPage {
  label {
    display: flex;
    align-items: flex-end;

    small {
      color: #dc3645;
      flex: 1;
      font-weight: bold;
      text-align: right;
    }
  }
}
</style>
